var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const createStyleTag = /* @__PURE__ */ __name(() => {
  if (!document) {
    return;
  }
  let style = document.querySelector("#mds-theme-style");
  if (!style) {
    style = document.createElement("style");
    style.id = "mds-theme-style";
    document.head.append(style);
    return style;
  }
}, "createStyleTag");

export { createStyleTag };
//# sourceMappingURL=create-style-tag.js.map
